import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-modal-lista-categorias',
  templateUrl: './modal-lista-categorias.component.html'
})
export class ModalListaCategoriasComponent implements OnInit {
  @Input()
  listaCategoriasRnt: Array<any> = [];

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    console.log(this.listaCategoriasRnt)
  }

  confirm(): void {
    this.activeModal.close();
  }

}
